import { render } from "./featureCard.vue?vue&type=template&id=fef9b97c&scoped=true"
import script from "./featureCard.vue?vue&type=script&lang=js"
export * from "./featureCard.vue?vue&type=script&lang=js"

import "./featureCard.vue?vue&type=style&index=0&id=fef9b97c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fef9b97c"]])

export default __exports__